<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">ONE<br/>Dharma</span></p>
<p class="center">THE EMERGING WESTERN BUDDHISM</p>
<p class="center1">Joseph Goldstein</p>
<p class="center"><span class="img"><img alt="" src="OEBPS/images/9780062026361_L01.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062026361_epub_tp_r1.vue?11cfe7c4